import { Brand } from 'effect';

export type NotificationSubscriberId = string &
  Brand.Brand<'NotificationSubscriberId'>;
export const NotificationSubscriberId =
  Brand.nominal<NotificationSubscriberId>();

export interface NotificationType {
  message: React.ReactNode;
  type?: 'info' | 'success' | 'danger';
  durationInMs?: number;
  component?: any;
}

export const NOTIFICATION_DEFAULT_DISPLAY_DURATION = 4500;
export const NOTIFICATION_INFINITE_DISPLAY_DURATION = 0;

export interface NotificationSubscriber {
  handleNewNotification(
    notification: NotificationType & {
      id: string;
    },
  ): void;
}

export interface NotificationService {
  subscribe(Subscriber: NotificationSubscriber): NotificationSubscriberId;

  unsubscribe(notificationSubscriberId: NotificationSubscriberId): void;

  notify(notification: NotificationType): void;
}

export const mockNotificationService = ({
  subscribe = () => NotificationSubscriberId('id'),
  unsubscribe = () => {},
  notify = () => {},
}: Partial<NotificationService> = {}): NotificationService => ({
  subscribe,
  unsubscribe,
  notify,
});
